import { ActionTypes } from '../actions/types';

const initialState = {
  loading: false,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.LOADING: {
      return {
        ...state,
        loading: payload,
      };
    }

    default:
      return state;
  }
}
